import React from 'react';
import { useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { InterviewSchedule } from 'features/sendouts/components/forms';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import NumberedForm from 'UI/components/molecules/NumberedForm';

import { FORM_FIELDS_MAP } from '../../drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import { OtherInterviewerFields } from '../../shared';

import { InterviewEmailNotificationsFields } from './InterviewEmailNotificationsFields';
import { NumberedFormWrapper } from './SendoutInterviewForm.styled';

const { sections: STRINGS } = strings.sendoutsV2.form;

export const SendoutInterviewForm = ({ allowPastDate = false }) => {
  const { watch } = useFormContext();
  const formValues = watch([
    FORM_FIELDS_MAP.InterviewDate.key,
    FORM_FIELDS_MAP.InterviewTimeFrame.key,
    FORM_FIELDS_MAP.InterviewFromHour.key,
    FORM_FIELDS_MAP.InterviewTimezone.key
  ]);

  const isInterviewScheduleComplete =
    !!formValues[FORM_FIELDS_MAP.InterviewTimeFrame.key] &&
    !!formValues[FORM_FIELDS_MAP.InterviewFromHour.key] &&
    !!formValues[FORM_FIELDS_MAP.InterviewTimezone.key] &&
    !!formValues[FORM_FIELDS_MAP.InterviewDate.key];

  return (
    <Grid container>
      <NumberedFormWrapper item xs={12}>
        <NumberedForm>
          <NumberedForm.Item title={STRINGS.interviewDetails.title}>
            <InterviewSchedule allowPastDate={allowPastDate} />
          </NumberedForm.Item>
          <When condition={isInterviewScheduleComplete}>
            <NumberedForm.Item title={STRINGS.otherInterviewer.title}>
              <OtherInterviewerFields />
            </NumberedForm.Item>
          </When>
          <When condition={isInterviewScheduleComplete}>
            <NumberedForm.Item title={STRINGS.emailNotifications.title}>
              <InterviewEmailNotificationsFields />
            </NumberedForm.Item>
          </When>
        </NumberedForm>
      </NumberedFormWrapper>
    </Grid>
  );
};
